/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export interface PaginationModel {
  limit: number;
  next_cursor: string | null;
  has_more: boolean;
}
